// extracted by mini-css-extract-plugin
export default {"container":"LearningGoalsRating__container___gpy9g","rightContainer":"LearningGoalsRating__rightContainer____3orF","skeleton-loading":"LearningGoalsRating__skeleton-loading___ri_ty"};